const findingTypeEnum = {
  threat: 'Threat',
  note: 'Note',
  dismissed: 'Dismissed',
  unclassified: 'Unclassified',
};

export default findingTypeEnum;
